<template>
  <div class="flex_vertial">
    <div class="center_content">
      <div class="head_title_left">请输入需要开通服务的号码</div>
      <div class="num_layout">
        <div class="tips">+86</div>
        <div class="divider"></div>
        <input class="phone_input" type="text" name="phone" maxlength=11 @input="validInput" placeholder="请输入手机号码"/>
      </div>
      <div class="dividerline"></div>
    </div>
    <div @click="sendVerifyCode" v-bind:class="{open_button_gray: !validNum, open_button: validNum}"
    >获取验证码
    </div>
  </div>
</template>

<script>
import util from '@/utils/util'
import app from '@/AppData'
import lubanApi from '@/lubanApi'

export default {
  name: 'bindPhone',
  data () {
    return {
      validNum: false,
      num: ''
    }
  },
  methods: {
    sendVerifyCode () {
      if (this.validNum) {
        // send 发送验证码
        const tryToBindNum = this.num
        lubanApi.sendPhoneCode(tryToBindNum).then(res => {
          if (res.data.code === 0 && res.data.data.resp.ret === 0) {
            console.log('sendPhoneCode success', res)
            app.setData('tryToBindNum', tryToBindNum)
            this.$router.replace({
              path: '/bind_phone_verify'
            })
          } else {
            console.error('sendPhoneCode failed1', res.data)
            util.Toast('发送验证码失败，请稍后重试')
          }
        }).catch(err => {
          console.error('sendPhoneCode failed2', err)
          util.Toast('发送验证码失败，请稍后重试')
        })
      }
    },
    validInput (event) {
      event.target.value = event.target.value.replace(/[^\d]/g, '')
      if (util.isPhoneNumber(event.target.value)) {
        this.validNum = true
        this.num = event.target.value
      } else {
        this.validNum = false
        this.num = ''
      }
    }
  },
  mounted () {
    lubanApi.reportseer('AICall_Open_Function_Setting_Page_Shown')
  }
}
</script>

<style scoped lang="less" src="@/styles/common.less"/>
<style scoped>

.phone_input {
  box-sizing: border-box;
  width: calc(100% - 4rem);
  font-size: 1rem;
  letter-spacing: 0.1rem;
  line-height: 1.4rem;
  background: none;
  border: none;
  outline: none;
}

.num_layout {
  box-sizing: border-box;
  width: calc(100% - 4rem);
  height: 2rem;
  display: flex;
  flex-direction: row;
  justify-content: center; /* 水平居中 */
  align-items: center; /* 垂直居中 */
  margin-top: 0.5rem;
}

.dividerline {
  box-sizing: border-box;
  width: calc(100% - 4rem);
  height: 0.01rem;
  border: 0.5px solid #DDDDDD;
}

.divider {
  width: 0.01rem;
  height: 1.5rem;
  border: 0.5px solid #DDDDDD;
  margin-left: 1rem;
  margin-right: 1rem;
}

.tips {
  font-family: PingFangSC-Regular;
  font-size: 1rem;
  color: #3B3B3B;
  line-height: 1.4rem;
}

</style>



// WEBPACK FOOTER //
// src/components/bind/BindPhone.vue